import React, { useMemo } from 'react';

const MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiZGFuaWVsa2FsZG9yIiwiYSI6ImNtYjRyNTYzczA1emcya3FwdzhoMmhmdGIifQ.qkeEKxO6j5ugrpbdC06grA';

const ActivityMap = ({ activity, width = 300, height = 200, interactive = false, selectedSegment = null }) => {
  const staticMapUrl = useMemo(() => {
    if (!activity || !activity.map || !activity.map.summary_polyline) return null;

    try {
      const style = 'samuelcollin3333/cmcyoppzj00ds01rf0gjpbt16';

      // If a segment is selected and has a polyline, show it highlighted
      // Check for polyline in segment.map.polyline (full) or segment.map.summary_polyline (summary)
      const segmentPolylineData = selectedSegment?.segment?.map?.polyline || selectedSegment?.segment?.map?.summary_polyline;
      if (selectedSegment && segmentPolylineData) {
        const segmentPolyline = encodeURIComponent(segmentPolylineData);
        const activityPolyline = encodeURIComponent(activity.map.summary_polyline);
        // Show activity route in gray and segment highlighted in orange
        const activityPathString = `path-3+999999-0.4(${activityPolyline})`;
        const segmentPathString = `path-5+FC5200-1(${segmentPolyline})`;
        return `https://api.mapbox.com/styles/v1/${style}/static/${activityPathString},${segmentPathString}/auto/${width}x${height}@2x?padding=20&attribution=false&logo=false&access_token=${MAPBOX_ACCESS_TOKEN}`;
      }

      // Default: show full activity route
      const encodedPolyline = encodeURIComponent(activity.map.summary_polyline);
      const pathString = `path-5+FC5200-1(${encodedPolyline})`;
      return `https://api.mapbox.com/styles/v1/${style}/static/${pathString}/auto/${width}x${height}@2x?padding=20&attribution=false&logo=false&access_token=${MAPBOX_ACCESS_TOKEN}`;
    } catch (error) {
      console.error('Error generating static map URL:', error);
      return null;
    }
  }, [activity, width, height, selectedSegment]);

  if (!activity || !activity.map || !activity.map.summary_polyline) {
    return (
      <div style={{
        width: `${width}px`,
        height: `${height}px`,
        background: '#f5f0e8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6b6b6b',
        fontSize: '12px',
        borderRadius: '8px'
      }}>
        No map data
      </div>
    );
  }

  if (!staticMapUrl) {
    return (
      <div style={{
        width: `${width}px`,
        height: `${height}px`,
        background: '#f5f0e8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6b6b6b',
        fontSize: '12px',
        borderRadius: '8px'
      }}>
        Loading map...
      </div>
    );
  }

  return (
    <img 
      src={staticMapUrl} 
      alt="Activity route" 
      style={{ 
        width: '100%', 
        height: '100%', 
        objectFit: 'cover',
        borderRadius: '8px'
      }}
    />
  );
};

export default ActivityMap;

